import { autoCompleteRequest } from './codesets';
import { Search } from './controls';
import { CodeSet, Diagnosis, Procedure } from './domain';
import { FormApi, formApi } from './form';
import { IcdCptApi } from './icd-cpt-api';
import { updateElement } from './codesets';
import React from 'react';
type ReviseCodeFormProps = {
  target: CodeSet;
  api?: IcdCptApi; //TODO configurable providers
  onCodeFound?: (code: Diagnosis | Procedure) => void;
};

const cptFilter = (v: CodeSet) => v.codeType !== 'ICD_10';
const dxFilter = (v: CodeSet) => v.codeType === 'ICD_10';

let lastCodeSet: CodeSet = null;

export function ReviseCodeForm(props: ReviseCodeFormProps) {
  const { target, onCodeFound } = props;
  target.code = target.diagnosisCode || target.cptCode;
  const filter = target.diagnosisCode ? dxFilter : cptFilter;

  function onSubmit(f: { code: any }) {
    const v = f.code || lastCodeSet;
    console.log('onSubmit', typeof f?.code, v);

    if (v?.code) {
      updateElement(target, v);
      if (onCodeFound) {
        onCodeFound(target);
      }
    }
  }

  const form: FormApi<any> = formApi({
    values: { code: target },
    onSubmit,
    valid: (f) => f.code,
    fields: {
      code: {
        label: 'Revise Code',
        required: true,
        list: [],
        listLabel: (c: CodeSet) =>
          (c?.description && c.code + ' - ' + c.description.longDescription) ||
          '',
        textLabel: (c: CodeSet) => c?.code || '',
        onEnter: () => form.submit(),
        onChange: (code: CodeSet) => {
          if (typeof code === 'string') {
            search(code as string);
          } else if (code) {
            onSubmit({ code });
          }
        },
        onInputChange: async (v: string) => {
          search(v);
        },
      },
    },
  });

  let pendingSearch = false;
  async function search(v: string) {
    v = (v || '').trim().toUpperCase();

    if (!pendingSearch && v && v.length >= 2) {
      pendingSearch = true;

      let r: CodeSet[] = await autoCompleteRequest({ code: v });
      r = r.filter(filter);

      if (r) {
        if (r.length) {
          code.list.getState().setValue(r);

          if (r.length === 1) {
            code.value.setState({ value: r[0] });

            onSubmit({ code: r[0] });
          } else {
            const match = r.filter((a) => a.code === v)[0];

            if (match) {
              code.value.setState({ value: match });
              onSubmit({ code: match });
            }
          }
        }
      }
      pendingSearch = false;
    }
  }

  const { code } = form.controls;

  return <Search {...code} />;
}
